import React, { useEffect, useState,useCallback } from "react";
import CancelInspectionModal from "./CancelInspectionModal.js";
import AssignInspectionModal from "./AssignInspectionModal.js";
import ReassignModal from "./ReassignModal.js";
import "bootstrap/dist/css/bootstrap.css";
import "./style.css";
import pdficon from "./img/pdf.png"
import cancelInspectionIcon from "./img/Cancel Inspection.png";
import assignInspectionIcon from "./img/assign.png";
import reassignIcon from "./img/Reassign.png";
import editIcon from "./img/Edit.png";
import archiveIcon from "./img/Archive.png";
import viewInspectionIcon from "./img/Group.png";
import filterIcon from "./img/filter.png";
import HistoryIcon from '@mui/icons-material/History';
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { apiCall } from "../../services/ApiCall.js";
import config from "../../config/config.json";
import { Button, Modal } from "react-bootstrap";
import { Button as MuiButton } from '@mui/material'
import Loader from "../CompanyFolder/CompanyList/Loader.js";
import { IoChevronBackCircle } from "react-icons/io5";
import * as XLSX from 'xlsx';
import Snackbar from '@mui/material/Snackbar';
import { Menu, MenuItem, IconButton } from '@mui/material';// added
import MoreVertIcon from '@mui/icons-material/MoreVert';//add


import {
  Box,
  Paper,
  Typography,
  TextField,
  Select,
  FormControl,
  InputLabel,
  Stack,
  InputAdornment,
  Grid,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Badge,
  Tooltip,
  Alert,
  useTheme,
  useMediaQuery,
   Card, 
  CardContent, 
  CardHeader, 
   Switch, 

} from '@mui/material';
import {
  Search as SearchIcon,
  FilterList as FilterListIcon,
  FileDownload as FileDownloadIcon,
  NotificationsActive as NotificationsActiveIcon,
  Add as AddIcon,
  Clear as ClearIcon,
  Business as BusinessIcon,
  LocationOn as LocationIcon,
  Person as PersonIcon,
} from '@mui/icons-material';



import { Resizable } from 'react-resizable';
import EditIcon from '@mui/icons-material/Edit';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import CachedIcon from '@mui/icons-material/Cached';
import ArchiveIcon from '@mui/icons-material/Archive';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CancelIcon from '@mui/icons-material/Cancel';
import RequestTimeline from "./RequestTimeline.js";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CopyUrlsModal from './CopyLoginUrlsModal.js';
import ReminderButton from "./Reminder.js";
import { CanWrite, CanAssignRequest } from "../../context/AuthContext.jsx";


const ResizableTableCell = ({ onResize, width, ...props }) => {
  return (
    <Resizable
      width={width}
      height={0}
      handle={
        <span
          className="react-resizable-handle"
          onClick={e => e.stopPropagation()}
          style={{ position: 'absolute', right: 0, top: 0, bottom: 0, width: '5px', cursor: 'col-resize' }}
        />
      }
      onResize={onResize}
      draggableOpts={{ enableUserSelectHack: false }}
    >
      <td {...props} style={{ width, position: 'relative' }} />
    </Resizable>
  );
};
const Inspections = ({ type, status }) => {
  const DEFAULT_API_USER_ID = config.DEFAULT_API_USER_ID;
  const navigate = useNavigate();
  const location = useLocation();
  
  // State for the dropdown menu
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentItemForMenu, setCurrentItemForMenu] = useState(null);

  // State for the timeline modal
  const [isTimelineOpen, setIsTimelineOpen] = useState(false);

  // Handlers for the dropdown menu
  const handleMenuOpen = useCallback((event, item) => {
    setAnchorEl(event.currentTarget);
    setCurrentItemForMenu(item);
  }, []);

  const handleMenuClose = useCallback(() => {
    setAnchorEl(null);
    setCurrentItemForMenu(null);
  }, []);

  // Handlers for the timeline modal
  //const handleOpenTimeline = useCallback((item) => {
    //setCurrentItemForMenu(item);
    //setIsTimelineOpen(true);
 // }, []);

  //const handleCloseTimeline = useCallback(() => {
  //  setIsTimelineOpen(false);
 // }, []);

  // --- END OF BLOCK TO PASTE ---

  // ... the rest of your state (requestData, searchTerm, etc.) and functions// The empty array [] means the function will never be recreated

  
  const [requestData, setRequestData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(50);
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");
  const [expandedRows, setExpandedRows] = useState({});
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resendModalIsOpen, setResendModalIsOpen] = useState(false);
  const [assignModalIsOpen, setAssignModalIsOpen] = useState(false);
  // const [selectedItem, setSelectedItem] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [reassignModelIsOpen, setReassignModalIsOpen] = useState(false);
  const [reassignItem, setReassignItem] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [actionMode, setActionMode] = useState("DELETE");
  const [requestId, setRequestId] = useState(null);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [RequestTimlineOpen, setRequestTimlineOpen] = React.useState(false);
  const handleRequestTimlineOpen = () => setRequestTimlineOpen(true);
  const handleRequestTimlineClose = () => setRequestTimlineOpen(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [copyModalOpen, setCopyModalOpen] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [designation, setDesignation] = useState('site-manager');
  const [filters, setFilters] = useState({
    status: '',
    dateRange: {
      startDate: '',
      endDate: ''
    },
    companyName: '',
    siteCity: '',
    siteState: ''
  });
  const [showARARequests, setShowARARequests] = useState('all');
 

 

  const primaryColor = "#0d6efd";  //
  const secondaryColor = "#F5A623";

  // Original status map (unchanged)
  const statusMap = {
    0: "New Request",
    1: "In-Progress",
    2: "To-Be-Approved",
    3: "Migrated",
    4: "Approved",
    5: "Waiting for Approval",
    6: "Renewal Scheduled",
    7: "Redo",
    8: "To be Approved",
    9: "Archived",
    10: "Expired",
  };

  const handleRowClick = (row) => {
     navigate(`/requestDetail/${row.id}`, {
       state: { requestId: row.id }
     });
   };

  // Original handler functions (unchanged logic)
  const handleOpenCopyModal = (item) => {
    setCurrentItem(item);
    setCopyModalOpen(true);
  };

  const handleCloseCopyModal = () => {
    setCopyModalOpen(false);
    setCurrentItem(null);
  };

  const handleAction = (event) => {
      event.stopPropagation();
    archiveRequest(requestId);
    setShowDeleteModal(false);
  };

  const handleReassignClick = (item) => {
    setReassignItem(item);
    setReassignModalIsOpen(true);
  };

  const handleAssigninspectionClick = (item) => {
    setSelectedItem(item);
    setCurrentItem(item); // Set current item for modal
    setAssignModalIsOpen(true);
  };

  const handleResendClick = () => {
    setResendModalIsOpen(true);
    console.log("Resend button clicked");
  };

  const handleCloseReassignModel = () => {
    setReassignModalIsOpen(false);
    setReassignItem(null);
  };
  
  const handleCloseAssignModal = () => {
    setSelectedItem(null);
    setSelectedItem(null);
    setAssignModalIsOpen(false);
  };

  const handleCloseResendModal = () => {
    setResendModalIsOpen(false);
  };

  const handleCancelClick = (id) => {
    setModalIsOpen(true);
    setActionMode("DELETE");
    setRequestId(id);
  };

  const handleCloseModal = () => {
    setModalIsOpen(false);
  };

  const handleFilterChange = (field, value) => {
    setFilters(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // Original filtering logic (unchanged)
const applyFilters = (data) => {
  return data.filter(item => {
    let matches = true;

    // ARA Filter - Check this first
    if (showARARequests === 'ara' && matches) {
      matches = item.createdBy?.toString() === DEFAULT_API_USER_ID?.toString();
    } else if (showARARequests === 'non-ara' && matches) {
      matches = item.createdBy?.toString() !== DEFAULT_API_USER_ID?.toString();
    }
    // If showARARequests === 'all', no filtering on this criteria

    if (filters.status && matches) {
      matches = item.status.toString() === filters.status;
    }

    if (filters.companyName && matches) {
      matches = item.companyName?.toLowerCase().includes(filters.companyName.toLowerCase());
    }

    if (filters.siteCity && matches) {
      matches = item.siteCity?.toLowerCase().includes(filters.siteCity.toLowerCase());
    }

    if (filters.siteState && matches) {
      matches = item.siteState?.toLowerCase().includes(filters.siteState.toLowerCase());
    }

    if (filters.dateRange.startDate && filters.dateRange.endDate && matches) {
      const itemDate = new Date(item.createdAt);
      const startDate = new Date(filters.dateRange.startDate);
      const endDate = new Date(filters.dateRange.endDate);
      matches = itemDate >= startDate && itemDate <= endDate;
    }

    return matches;
  });
};

  const filteredData = requestData?.length
    ? applyFilters(
        requestData.filter((item) =>
          ["siteId", "id", "araId", "name", "street", "siteAddress", "siteCity",
            "companyName", "state", "zipcode", "contactName", "contactPhone",
            "contactEmail"].some((key) =>
              item[key]?.toString().toLowerCase().includes(searchTerm.toLowerCase())
            )
        )
      )
    : [];

  const sortedData = filteredData.length
    ? filteredData.sort((a, b) => {
        if (!sortColumn) return 0;
        if (a[sortColumn] < b[sortColumn])
          return sortDirection === "asc" ? -1 : 1;
        if (a[sortColumn] > b[sortColumn])
          return sortDirection === "asc" ? 1 : -1;
        return 0;
      })
    : [];

  const indexOfLastEntry = currentPage * entriesPerPage;
  const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
  const currentEntries = sortedData.slice(indexOfFirstEntry, indexOfLastEntry);
  const totalPages = Math.ceil(filteredData.length / entriesPerPage);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleModeChange = (mode, id) => {
    setActionMode(mode);
    setRequestId(id);
    setShowDeleteModal(true);
  };

  const handleSortColumn = (column) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortDirection("asc");
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleViewMore = (id) => {
    setExpandedRows((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  // Original API functions (unchanged logic)
  const archiveRequest = async () => {
    let endpoint = "";

    if (actionMode === "DELETE") {
      endpoint = "cancelRequest";
    } else if (actionMode === "UNARCHIVE") {
      endpoint = "unArchiveRequest";
    } else {
      endpoint = "archiveRequest";
    }

    const { isSuccess, data } = await apiCall(
      `${config.POST_LOGIN_API_URL}${endpoint}`,
      {},
      { requestId },
      "POST"
    );

    if (isSuccess) {
      getRequestsList();
      handleCloseResendModal();
    }
  };

  const [queryParams, setQueryParams] = useState({});
  const [hashParams, setHashParams] = useState('');

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const paramsObject = {};
    for (let [key, value] of searchParams.entries()) {
      paramsObject[key] = value;
    }
    setQueryParams(paramsObject);
    const hash = location.hash;
    if (hash) {
      setHashParams(hash.substring(1));
    }
  }, [location]);

  const getRequestsList = async () => {
    setLoading(true)
    const msiId = queryParams.requestId;
    const match = location.pathname.match(/\/all-request\/view\/(\d+)/);

    const { isSuccess, data } = await apiCall(
      `${config.POST_LOGIN_API_URL}getRequestsList`,
      {},
      { type, status, siteId: match && match[1], requestId: msiId || null, accessType: msiId ? 'MAINCONTACT' : null },
      "GET"
    );
    setLoading(false);

    if (isSuccess) {
      setLoading(false)
      if (status == 4) {
        const sortedData = data?.data
          .filter(item => item.approvedDate !== null)
          .sort((a, b) => new Date(b.approvedDate) - new Date(a.approvedDate));
        setRequestData(sortedData);
      } else if (status == 2) {
        const sortedData = data?.data
          .filter(item => item.completedDate !== null)
          .sort((a, b) => new Date(b.completedDate) - new Date(a.completedDate));
        setRequestData(sortedData);
      } else {
        setRequestData(data?.data?.reverse());
      }
    }
  };

  useEffect(() => {
    const msiId = queryParams.requestId;
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/");
    }
    if (msiId)
      getRequestsList();
  }, [queryParams]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const match = location.pathname.match(/\/all-request(\/view\/\d+)?/);
    const searchParams = new URLSearchParams(location.search);
    const hideKeywordPresent = searchParams.has("hide");

    if (!token) {
      navigate("/");
    }
    if (match && !hideKeywordPresent) {
      getRequestsList();
    }
  }, [type, status, location]);

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(
      sortedData.map(site => ({
        'Request ID': site?.id,
        "ARA ID": site?.araId,
        "Company Name": site?.companyName,
        "Contact Name": site?.contactName,
        "Contact Email": site?.contactEmail,
        'Site Address': `${site?.siteAddress}, ${site?.siteCity}, ${site?.siteState}, ${site?.siteZipcode}`,
        "Site Admin Name": site?.siteAdminName,
        "Site Admin Email": site?.siteAdminEmail,
        "Site Manager Name": site?.siteManagerName,
        "Site Manager Email": site?.siteManagerEmail,
         "Inspection Due Date": site?.scheduledDate ? new Date(site.scheduledDate).toLocaleDateString('en-US', {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
        }).replace(/\//g, '-') : '',
        "Approval Date": site?.approvedDate ? new Date(site.approvedDate).toLocaleDateString('en-US', {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
        }).replace(/\//g, '-') : '',
        "Completed Date": site?.completedDate ? new Date(site.completedDate).toLocaleDateString('en-US', {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
        }).replace(/\//g, '-') : '',
        "Next Inspection Date": site?.scheduledDate ? new Date(site.scheduledDate).toLocaleDateString('en-US', {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
        }).replace(/\//g, '-') : '',
          "Data Form Complete": site?.isDataFormComplete === 1 ? 'True' : 'False',
      "Picture Form Complete": site?.isPictureFormComplete === 1 ? 'True' : 'False',
       "Status": statusMap[site?.status] || "Unknown Status", 
      }))
    );

    worksheet['!cols'] = [
      { wch: 10 }, { wch: 15 }, { wch: 40 }, { wch: 50 }, { wch: 30 },
      { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 15 },
      { wch: 15 }, { wch: 15 }, { wch: 15 },  { wch: 18 },
    { wch: 20 },{ wch: 20 },
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Request");
    XLSX.writeFile(workbook, "Request.xlsx");
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    const searchParams = new URLSearchParams(location.search);

    if (!token) {
      navigate("/");
    }

    const hideKeywordPresent = searchParams.has("hide");
    if (!hideKeywordPresent) {
      getRequestsList();
    }
  }, [type, status]);

  const renderPagination = () => {
    const pageNumbers = [];
    const totalPages = Math.ceil(filteredData.length / entriesPerPage);

    let startPage = currentPage - 1;
    let endPage = currentPage + 1;

    if (startPage < 1) {
      startPage = 1;
      endPage = 3;
    }

    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = totalPages - 2 > 0 ? totalPages - 2 : 1;
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <li
          key={i}
          className={`pagination-item ${currentPage === i ? "active" : ""}`}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </li>
      );
    }

    
           
           
return(
      <ul className="pagination">
        <li
          className={`pagination-item ${currentPage === 1 ? "disabled" : ""}`}
          onClick={handlePreviousPage}
        >
          Previous
        </li>
        {pageNumbers}
        <li
          className={`pagination-item ${currentPage === totalPages ? "disabled" : ""
            }`}
          onClick={handleNextPage}
        >
          Next
        </li>
      </ul>
    );
  };

  // Helper functions
  const hasActiveFilters = () => {
    return filters.status !== '' ||
      filters.dateRange.startDate !== '' ||
      filters.dateRange.endDate !== '' ||
      filters.companyName !== '' ||
      filters.siteCity !== '' ||
      filters.siteState !== '';
  };

  const clearAllFilters = () => {
    setFilters({
      status: '',
      dateRange: { startDate: '', endDate: '' },
      companyName: '',
      siteCity: '',
      siteState: ''
    });
  };

  return (
    <Box sx={{ p: { xs: 2, md: 3 }, maxWidth: '100%', overflow: 'hidden' }}>
      {/* Header Section */}
      <Paper elevation={0} sx={{ p: 3, mb: 3, backgroundColor: 'transparent' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
          <Box>
            <Typography variant="h4" sx={{ fontWeight: 600, color: 'black', mb: 1 }}>
              Inspections
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Manage inspection requests and assignments
            </Typography>
          </Box>
        </Box>

        {/* Controls Section */}
        {!queryParams?.hide && (
          <Grid container spacing={2} alignItems="center">
            {/* Show Entries */}
            <Grid item xs={12} sm={6} md={2}>
              <FormControl size="small" fullWidth>
                <InputLabel>Show entries</InputLabel>
                <Select
                  value={entriesPerPage}
                  onChange={(e) => setEntriesPerPage(Number(e.target.value))}
                  label="Show entries"
                >
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                  <MenuItem value={250}>250</MenuItem>
                  <MenuItem value={500}>500</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* Search Box */}
            <Grid item xs={12} sm={12} md={6}>
              <TextField
                fullWidth
                size="small"
                placeholder="Search by ID, Company, Site, Contact..."
                value={searchTerm}
                onChange={handleSearchChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: 'text.secondary' }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                  }
                }}
              />
            </Grid>

            {/* Action Buttons 
            <Grid item xs={12} sm={6} md={4}>
              <Stack direction="row" spacing={2} justifyContent="flex-end" flexWrap="wrap">
                <Tooltip title="Filter Results">
                  <IconButton
                    onClick={() => setShowFilterModal(true)}
                    sx={{
                      border: hasActiveFilters() ? `2px solid ${'#a3a3a3ff'}` : '1px solid #a3a3a3ff',
                      borderRadius: 1,
                     
                      '&:hover': {
                        backgroundColor: `${primaryColor}10`,
                        borderColor: '#a3a3a3ff',

                      },
                    }}
                  >
                    <Badge color="error" variant="dot" invisible={!hasActiveFilters()}>
                      <FilterListIcon sx={{ color: hasActiveFilters() ? '#696868ff' : 'inherit' }} />
                      
                    </Badge>
                  </IconButton>
                </Tooltip>*/}
                 <Grid item xs={12} sm={6} md={4}>
              <Stack direction="row" spacing={1} justifyContent="flex-end" flexWrap="wrap"  sx={{ gap: 1 }}>
             <Box
  sx={{
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
    border: '1px solid #e0e0e0',
    borderRadius: 2,
    p: 0.5,
    backgroundColor: '#f8f9fa',
  }}
>
  <Chip
    label="All Requests"
    onClick={() => setShowARARequests('all')}
    sx={{
      backgroundColor: showARARequests === 'all' ? primaryColor : 'transparent',
      color: showARARequests === 'all' ? 'white' : '#696868ff',
      fontWeight: showARARequests === 'all' ? 600 : 400,
      '&:hover': {
        backgroundColor: showARARequests === 'all' ? primaryColor : '#e0e0e0',
      },
      cursor: 'pointer',
      transition: 'all 0.3s ease',
    }}
  />
  <Chip
    label="ARA Requests"
    onClick={() => setShowARARequests('ara')}
    sx={{
      backgroundColor: showARARequests === 'ara' ? primaryColor : 'transparent',
      color: showARARequests === 'ara' ? 'white' : '#696868ff',
      fontWeight: showARARequests === 'ara' ? 600 : 400,
      '&:hover': {
        backgroundColor: showARARequests === 'ara' ? primaryColor : '#e0e0e0',
      },
      cursor: 'pointer',
      transition: 'all 0.3s ease',
    }}
  />
  <Chip
    label="Non-ARA"
    onClick={() => setShowARARequests('non-ara')}
    sx={{
      backgroundColor: showARARequests === 'non-ara' ? primaryColor : 'transparent',
      color: showARARequests === 'non-ara' ? 'white' : '#696868ff',
      fontWeight: showARARequests === 'non-ara' ? 600 : 400,
      '&:hover': {
        backgroundColor: showARARequests === 'non-ara' ? primaryColor : '#e0e0e0',
      },
      cursor: 'pointer',
      transition: 'all 0.3s ease',
    }}
  />
</Box>
               <MuiButton
  variant="outlined"
  onClick={() => setShowFilterModal(true)}
  startIcon={
    <Badge color="error" variant="dot" invisible={!hasActiveFilters()}>
      <FilterListIcon sx={{ color: hasActiveFilters() ? primaryColor : '#696868ff' }} />
    </Badge>
  }
  size="small"
  sx={{
    borderColor: hasActiveFilters() ? primaryColor : '#a3a3a3ff',
    color: hasActiveFilters() ? primaryColor : '#696868ff',
    '&:hover': {
      backgroundColor: `${'black'}10`,
      borderColor: '#a3a3a3ff',
    },
  }}
>
  Filter
</MuiButton>

                {hasActiveFilters() && (
                  <MuiButton
                    variant="outlined"
                    onClick={clearAllFilters}
                    startIcon={<ClearIcon />}
                    size="small"
                    sx={{
                      color: primaryColor,
                      borderColor: primaryColor,
                      '&:hover': {
                        backgroundColor: `${primaryColor}10`,
                        borderColor: primaryColor,
                      },
                    }}
                  >
                    Clear
                  </MuiButton>
                )}

                <MuiButton
                  variant="outlined"
                  startIcon={<FileDownloadIcon />}
                  onClick={exportToExcel}
                  size="small"
                  sx={{
                    borderColor: '#a3a3a3ff',
                    color: '#696868ff',
                   
                    '&:hover': {
                      backgroundColor: `${'black'}10`,
                      borderColor: '#a3a3a3ff',
                    }
                  }}
                >
                  Export
                </MuiButton>

                  <CanWrite>
                {status !== 9 && (
                  <NavLink to="/add-request" style={{ textDecoration: "none" }}>
                    <MuiButton
                      variant="contained"
                      startIcon={<AddIcon />}
                     
                      sx={{
                        backgroundColor: primaryColor,
                         width: { xs: '100%', sm: 'auto' },
                         padding:'10px 20px',
                         
                         fontSize:'14px',
                        '&:hover': {
                          backgroundColor: primaryColor,
                           opacity: 0.9,
                        }
                      }}
                    >
                      Add Request
                    </MuiButton>
                  </NavLink>
                )}
                  </CanWrite>
              </Stack>
            </Grid>
          </Grid>
        )}
      </Paper>

      {/* Data Table */}
      {!loading ? (
        <Paper elevation={1} sx={{ borderRadius: 2, overflow: 'hidden' }}>
          <Box sx={{ 
        display: { xs: 'none', md: 'block' }, 
        overflowX: 'auto' 
      }}>
            <table className="company-table " style={{ width: '100%', fontSize: "14px" }}>
              <thead >
                <tr style={{ backgroundColor: '#484646ff' }}>
  <th style={{ color: '#5f5e5eff', fontWeight: 600, padding: '16px 12px', width: '10%' }}>ID</th>
  <th style={{ color: '#5f5e5eff', fontWeight: 600, padding: '16px 12px', width: '10%' }}>ARA ID</th>
  <th style={{ color: '#5f5e5eff', fontWeight: 600, padding: '16px 12px', width: '15%' }}>Company</th>
  <th style={{ color: '#5f5e5eff', fontWeight: 600, padding: '16px 12px', width: '20%' }}>Site</th>
  <th style={{ color: '#5f5e5eff', fontWeight: 600, padding: '16px 12px', width: '15%' }}>Main Contact</th>
  {(Number(status) === 4 || type === "ALL") && (
    <th style={{ color: '#5f5e5eff', fontWeight: 600, padding: '16px 12px', width: '10%' }}>Approval</th>
  )}
  {(Number(status) === 2 || type === "ALL") && (
    <th style={{ color: '#5f5e5eff', fontWeight: 600, padding: '16px 12px', width: '10%' }}>Completed</th>
  )}
  {(Number(status) === 4 || type === "ALL") && (
    <th style={{ color: '#5f5e5eff', fontWeight: 600, padding: '16px 12px', width: '12%' }}>Next Inspection</th>
  )}
  {type === "ALL" && (
    <th style={{ color: '#5f5e5eff', fontWeight: 600, padding: '16px 12px', width: '10%' }}>Status</th>
  )}
  <th style={{ color: '#5f5e5eff', fontWeight: 600, padding: '16px 12px', width: '8%', textAlign: 'center' }}>Actions</th>
</tr>

              </thead>
              <tbody>
                {currentEntries.map((item) => (
                 <tr className="" key={item.id} style={{ position: 'relative' }}>
     <td style={{ padding: '12px 8px', position: 'relative', overflow: 'hidden' }}>
  {item.createdBy?.toString() === DEFAULT_API_USER_ID?.toString() && (
    <Box
      sx={{
        position: 'absolute',
        top: '2px',
        left: '0',
        width: '50px',
        height: '16px',
        background: 'linear-gradient(135deg, #0d6efd 0%, #0857d0 50%, #0a58ca 100%)',
        color: 'white',
        textAlign: 'center',
        fontSize: '9px',
        fontWeight: 700,
        lineHeight: '16px',
        transform: 'rotate(-45deg) translate(-24px, 11px)',
        transformOrigin: 'top left',
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.2)',
        letterSpacing: '0.9px',
        zIndex: 10,
        pointerEvents: 'none',
        textTransform: 'uppercase',
        border: '0.5px solid rgba(255, 255, 255, 0.2)',
        borderLeft: 'none',
        borderTop: 'none',
      }}
    >
      ARA
    </Box>
  )}
  {item?.id}
</td>
                    <td style={{ padding: '12px 8px' }}  onClick={!queryParams?.hide ? () => handleRowClick(item) : undefined} className="clickable-row">{item?.araId}</td>
                    <td style={{ padding: '12px 8px' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <BusinessIcon sx={{ color: primaryColor, fontSize: 18 }} />
                        {item?.companyName}
                      </Box>
                    </td>
                    <td style={{ padding: '12px 8px' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <LocationIcon sx={{ color: 'text.secondary', fontSize: 16 }} />
                        {item?.siteAddress}, {item?.siteCity}, {item?.siteState}
                      </Box>
                    </td>
                    <td style={{ padding: '12px 8px' }}>
                      {item?.contactName && (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <PersonIcon sx={{ color: 'text.secondary', fontSize: 16 }} />
                          <Box>
                            <div style={{ fontWeight: 500 }}>{item?.contactName}</div>
                            <div style={{ fontSize: '0.75rem', color: 'text.secondary' }}>{item?.contactPhone}</div>
                          </Box>
                        </Box>
                      )}
                    </td>
                    {(Number(status) === 4 || type === "ALL") && (
                      <td style={{ padding: '12px 8px' }}>
                        {item?.approvedDate && new Date(item?.approvedDate).toLocaleDateString(
                          "en-US",
                          { year: "numeric", month: "long", day: "numeric" }
                        )}
                      </td>
                    )}
                    {(Number(status) === 2 || type === "ALL") && (
                      <td style={{ padding: '12px 8px' }}>
                        {item?.completedDate && new Date(item?.completedDate).toLocaleDateString(
                          "en-US",
                          { year: "numeric", month: "long", day: "numeric" }
                        )}
                      </td>
                    )}
                    {(Number(status) === 4 || type === "ALL") && (
                      <td style={{ padding: '12px 8px' }}>
                        {item?.inspectionDate && new Date(item?.inspectionDate).toLocaleDateString(
                          "en-US",
                          { year: "numeric", month: "long", day: "numeric" }
                        )}
                      </td>
                    )}
                    {type === "ALL" && (
                      <td style={{ padding: '12px 8px' }}>
                        <div className={`status-${item?.status}`}>
                          {statusMap[item?.status] || "Unknown Status"}
                        </div>
                      </td>
                    )}
                    {/*
                    <td style={{ padding: '12px 8px' }}>
                      {Number(status) === 9 ? (
                        <img
                          className="mx-2 cursor-pointer"
                          src={archiveIcon}
                          alt="Unarchive"
                          title="Unarchive"
                          onClick={() => handleModeChange("UNARCHIVE", item.id)}
                          style={{ width: '20px', cursor: 'pointer' }}
                        />
                      ) : !expandedRows[item.id] ? (
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
                          {queryParams?.hide ? (
                            (item?.status == 0 || item?.status == 1) && (
                              <>
                                <img
                                  className="mx-2 cursor-pointer"
                                  src={assignInspectionIcon}
                                  alt="Assign Inspection"
                                  title="Assign Inspection"
                                  onClick={handleAssigninspectionClick}
                                  style={{ width: '20px', cursor: 'pointer' }}
                                />
                                <AssignInspectionModal
                                  getRequestsList={getRequestsList}
                                  isOpen={assignModalIsOpen}
                                  item={item}
                                  onRequestClose={handleCloseAssignModal}
                                />
                              </>
                            )
                          ) : (
                            <NavLink
                              to="/request-form"
                              state={{ requestId: item.id, requestData: item }}
                              style={{ textDecoration: "none" }}
                            >
                              <img
                                className="mx-2 cursor-pointer"
                                src={editIcon}
                                alt="Edit"
                                title="Edit Form"
                                style={{ width: '20px', cursor: 'pointer' }}
                              />
                            </NavLink>
                          )}

                          {!queryParams?.hide && (
                            <>
                              <NavLink to="/view-pdf-report"

                                state={{ requestId: item.id, requestData: item }}

                                 style={{ textDecoration: "none" }}
                              >
                                <IconButton size="small" sx={{ color: primaryColor }}></IconButton>
                                <img
                                  className="mx-2 cursor-pointer"
                                  src={pdficon}
                                  alt="View PDF"
                                  title="View PDF"
                                  style={{ width: '20px', cursor: 'pointer' }}
                                />
                              </NavLink>

                              {status <= 1 && (
                                <ReminderButton itemId={item.id} status={status} />
                              )}

                              <RequestTimeline itemId={item.id} />

                              <button
                                className="view-request-button btn btn-link p-1"
                                style={{
                                  border: "1px solid #0050A4",
                                  textDecoration: "none",
                                  backgroundColor: "#0050A4",
                                  color: "white",
                                  fontSize: "12px",
                                  borderRadius: "4px",
                                  padding: "4px 8px",
                                }}
                                onClick={() => handleViewMore(item.id)}
                              >
                                {expandedRows[item.id] ? 'View Less' : 'View More'}
                              </button>
                            </>
                          )}
                        </div>
                      ) : (
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
                          {queryParams?.hide ? (
                            (item?.status == 0 || item?.status == 1) && (
                              <>
                                <img
                                  className="mx-2 cursor-pointer"
                                  src={assignInspectionIcon}
                                  alt="Assign Inspection"
                                  title="Assign Inspection"
                                  onClick={handleAssigninspectionClick}
                                  style={{ width: '20px', cursor: 'pointer' }}
                                />
                                <AssignInspectionModal
                                  getRequestsList={getRequestsList}
                                  isOpen={assignModalIsOpen}
                                  item={item}
                                  onRequestClose={handleCloseAssignModal}
                                />
                              </>
                            )
                          ) : (
                            <NavLink
                              to="/request-form"
                              state={{ requestId: item.id, requestData: item }}
                              style={{ textDecoration: "none" }}
                            >
                              <img
                                className="mx-2 cursor-pointer"
                                src={editIcon}
                                alt="Edit"
                                title="Edit Form"
                                style={{ width: '20px', cursor: 'pointer' }}
                              />
                            </NavLink>
                          )}

                          {!queryParams?.hide && (
                            <>
                              <CanWrite>
                              <img
                                className="mx-2 cursor-pointer"
                                src={cancelInspectionIcon}
                                alt="Cancel Inspection"
                                title="Cancel Inspection"
                                onClick={() => handleCancelClick(item.id)}
                                style={{ width: '20px', cursor: 'pointer' }}
                              />
                              </CanWrite>
                              <CancelInspectionModal
                                isOpen={modalIsOpen}
                                onRequestClose={handleCloseModal}
                                onConfirm={archiveRequest}
                              />

                              {(item?.status == 0 || item?.status == 1) && (
                                <>
                                  <img
                                    className="mx-2 cursor-pointer"
                                    src={assignInspectionIcon}
                                    alt="Assign Inspection"
                                    title="Assign Inspection"
                                    onClick={() => handleAssigninspectionClick(item)}
                                    style={{ width: '20px', cursor: 'pointer' }}
                                  />
                                  <AssignInspectionModal
                                    getRequestsList={getRequestsList}
                                    isOpen={assignModalIsOpen}
                                    item={item}
                                    onRequestClose={handleCloseAssignModal}
                                  />
                                </>
                              )}

                              {status <= 1 && (
                                <ReminderButton itemId={item.id} status={status} />
                              )}

                              <RequestTimeline itemId={item.id} />

                              <img
                                className="mx-2 cursor-pointer"
                                src={reassignIcon}
                                alt="Reassign"
                                title="Reassign"
                                onClick={() => handleReassignClick(item)}
                                style={{ width: '20px', cursor: 'pointer' }}
                              />

                              <CanWrite>
                              <img
                                className="mx-2 cursor-pointer"
                                src={archiveIcon}
                                alt="Archive"
                                title="Archive"
                                onClick={() => handleModeChange("EDIT", item.id)}
                                style={{ width: '20px', cursor: 'pointer' }}
                              />
                              </CanWrite>

                              <ContentCopyIcon
                                className="mx-2 cursor-pointer"
                                onClick={() => handleOpenCopyModal(item)}
                                title="Open Copy URLs"
                                style={{ color: '#0050A4', cursor: 'pointer', fontSize: '20px' }}
                              />

                              <button
                                className="view-request-button btn btn-link p-1"
                                style={{
                                  border: "1px solid green",
                                  textDecoration: "none",
                                  backgroundColor: "green",
                                  color: "white",
                                  fontSize: "12px",
                                  borderRadius: "4px",
                                  padding: "4px 8px",
                                }}
                                onClick={() => handleViewMore(item.id)}
                                title="View Less"
                              >
                                View Less
                              </button>
                            </>
                          )}
                        </div>
                      )}
                    </td>*/}
              <td style={{ padding: '12px 8px', textAlign: 'center',verticalAlign: 'middle',position: 'relative' }}>

  {/* This IconButton is the new three-dot trigger */}
  <IconButton
    aria-label="more actions"
    aria-haspopup="true"
    onClick={(event) => handleMenuOpen(event, item)}
    sx={{
      padding: '8px',
      '&:hover': {
        backgroundColor: 'rgba(13, 110, 253, 0.04)',
      },
      '& .MuiSvgIcon-root': {
        fontSize: '20px',
        color: '#666',
      }
    }}
  >
    <MoreVertIcon />
  </IconButton>

  {/* This Menu component is the same dropdown as before  <Menu
    anchorEl={anchorEl}
    open={anchorEl && currentItemForMenu?.id === item.id}
    onClose={handleMenuClose}
  > */}
  <Menu
    anchorEl={anchorEl}
    open={Boolean(anchorEl) && currentItemForMenu?.id === item.id}
    onClose={handleMenuClose}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    sx={{
      '& .MuiPaper-root': {
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        borderRadius: '8px',
        marginTop: '4px',
      },
      '& .MuiMenuItem-root': {
        padding: '8px 16px',
        fontSize: '14px',
        '&:hover': {
          backgroundColor: 'rgba(13, 110, 253, 0.08)',
        }
      }
    }}
  >
    {/* Edit Action */}
    <CanWrite>
    {!queryParams?.hide && (
      <MenuItem 
        component={NavLink} 
        to="/request-form" 
        state={{ requestId: currentItemForMenu?.id, requestData: currentItemForMenu }} 
        onClick={handleMenuClose}
      >
        Edit Form
      </MenuItem>
      
    )}
    </CanWrite>

    {/* View PDF Action */}
    {!queryParams?.hide && (
      <MenuItem 
        component={NavLink} 
        to="/view-pdf-report" 
        state={{ requestId: currentItemForMenu?.id, requestData: currentItemForMenu }} 
        onClick={handleMenuClose}
      >
        View PDF
      </MenuItem>
    )}

    {/* Assign Inspection Action (conditional) */}
    <CanAssignRequest>
    {(item?.status == 0 || item?.status == 1) && (
      <MenuItem onClick={() => { handleAssigninspectionClick(currentItemForMenu); handleMenuClose(); }}>
        Assign Inspection
      </MenuItem>
    )}
    </CanAssignRequest>

    {/* Cancel Inspection Action */}
    <CanWrite>
    {!queryParams?.hide && (
      <MenuItem onClick={() => { handleCancelClick(currentItemForMenu?.id); handleMenuClose(); }}>
        Cancel Inspection
      </MenuItem>
    )}
    </CanWrite>
    
    {/* Reassign Action */}
    <CanAssignRequest>
    {!queryParams?.hide && (
       <MenuItem onClick={() => { handleReassignClick(currentItemForMenu); handleMenuClose(); }}>
        Reassign
      </MenuItem>
    )}
    </CanAssignRequest>

    {/* Archive Action */}
    <CanWrite>
    {!queryParams?.hide && (
      <MenuItem onClick={() => { handleModeChange("EDIT", currentItemForMenu?.id); handleMenuClose(); }}>
        Archive
      </MenuItem>
    )}
    </CanWrite>
    
    {/* Copy URL Action */}
    {!queryParams?.hide && (
      <MenuItem onClick={() => { handleOpenCopyModal(currentItemForMenu); handleMenuClose(); }}>
        Copy URLs
      </MenuItem>
    )}
    
    {/* Other Actions integrated as MenuItems 
    {!queryParams?.hide && status <= 1 && (
      
      <MenuItem onClick={handleMenuClose}>
         <ReminderButton itemId={item.id}  status={status} isMenuItem/>
          
     </MenuItem>
     
         
         
    )}
    <RequestTimeline itemId={item.id} /> 
       </Menu>  */}
       {!queryParams?.hide && status <= 1 && (
  <MenuItem onClick={handleMenuClose}>
    <ReminderButton itemId={item.id} status={status} isMenuItem />
  </MenuItem>
)}
<MenuItem 
  sx={{ 
    display: 'flex', 
    alignItems: 'center', 
    gap: 1,
    padding: '8px 16px',
    cursor: 'pointer'
  }}
  onClick={(e) => {
    const timelineButton = e.currentTarget.querySelector('button');
    if (timelineButton) {
      timelineButton.click();
    }
  }}
>
  
  <span>View Timeline</span>
  
  <div style={{ position: 'absolute', left: '-9999px', opacity: 0, pointerEvents: 'none' }}>
    <RequestTimeline itemId={item.id} />
  </div>
</MenuItem>
</Menu>
</td>
 
                  </tr>
                ))}
      
              </tbody>
            </table>
          </Box>
          
            <Box sx={{ display: { xs: 'block', md: 'none' }, p: 1 }}>
        {currentEntries.map((item) => (
           <Card 
      key={item.id} 
      sx={{ 
        mb: 2, 
        borderRadius: 2,
        border: '1px solid #e0e0e0',
        overflow: 'hidden',
        position: 'relative', // Added for badge positioning
      }}
    >
      {/* ARA Badge for Mobile */}
      {item.createdBy?.toString() === DEFAULT_API_USER_ID?.toString() && (
        <Box
          sx={{
            position: 'absolute',
            top: '0',
            left: '0',
            width: '50px',
            height: '18px',
            background: 'linear-gradient(135deg, #0d6efd 0%, #0857d0 50%, #0a58ca 100%)',
            color: 'white',
            textAlign: 'center',
            fontSize: '9px',
            fontWeight: 700,
            lineHeight: '18px',
            paddingLeft: '4px',
            transform: 'rotate(-45deg) translate(-26px, 12px)',
            transformOrigin: 'top left',
            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.2)',
            letterSpacing: '0.9px',
            zIndex: 10,
            pointerEvents: 'none',
            textTransform: 'uppercase',
            border: '0.5px solid rgba(255, 255, 255, 0.2)',
            borderLeft: 'none',
            borderTop: 'none',
          }}
        >
          ARA
        </Box>
      )}

            {/* Card Header */}
            <CardHeader
              sx={{ 
                backgroundColor: `${primaryColor}08`,
                pb: 1,
                pt: 2
              }}
              title={
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <Box>
                    <Typography variant="h6" sx={{ color: primaryColor, fontWeight: 600, fontSize: '16px' }}>
                      ID: {item?.id}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '12px' }}>
                      ARA ID: {item?.araId}
                    </Typography>
                  </Box>
                  {type === "ALL" && (
                    <Chip 
                      label={statusMap[item?.status] || "Unknown Status"}
                      className={`status-${item?.status}`}
                      size="small"
                      sx={{ fontSize: '10px' }}
                    />
                  )}
                </Box>
              }
            />

            <CardContent sx={{ pt: 1, pb: 1 }}>
              {/* Company Info */}
              <Box sx={{ mb: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                  <BusinessIcon sx={{ color: primaryColor, fontSize: 18 }} />
                  <Typography variant="body1" sx={{ fontWeight: 500, fontSize: '14px' }}>
                    {item?.companyName}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, ml: 3 }}>
                  <LocationIcon sx={{ color: 'text.secondary', fontSize: 16, mt: 0.2 }} />
                  <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '12px' }}>
                    {item?.siteAddress}, {item?.siteCity}, {item?.siteState}
                  </Typography>
                </Box>
              </Box>

              {/* Contact Info */}
              {item?.contactName && (
                <Box sx={{ mb: 2 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <PersonIcon sx={{ color: 'text.secondary', fontSize: 16 }} />
                    <Box>
                      <Typography variant="body2" sx={{ fontWeight: 500, fontSize: '13px' }}>
                        {item?.contactName}
                      </Typography>
                      <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '11px' }}>
                        {item?.contactPhone}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              )}

              {/* Date Information */}
              <Box sx={{ mb: 2 }}>
                {(Number(status) === 4 || type === "ALL") && item?.approvedDate && (
                  <Box sx={{ mb: 1 }}>
                    <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '11px', fontWeight: 500 }}>
                      Approval:
                    </Typography>
                    <Typography variant="body2" sx={{ fontSize: '12px' }}>
                      {new Date(item?.approvedDate).toLocaleDateString("en-US", { 
                        year: "numeric", 
                        month: "long", 
                        day: "numeric" 
                      })}
                    </Typography>
                  </Box>
                )}

                {(Number(status) === 2 || type === "ALL") && item?.completedDate && (
                  <Box sx={{ mb: 1 }}>
                    <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '11px', fontWeight: 500 }}>
                      Completed:
                    </Typography>
                    <Typography variant="body2" sx={{ fontSize: '12px' }}>
                      {new Date(item?.completedDate).toLocaleDateString("en-US", { 
                        year: "numeric", 
                        month: "long", 
                        day: "numeric" 
                      })}
                    </Typography>
                  </Box>
                )}

                {(Number(status) === 4 || type === "ALL") && item?.inspectionDate && (
                  <Box sx={{ mb: 1 }}>
                    <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '11px', fontWeight: 500 }}>
                      Next Inspection:
                    </Typography>
                    <Typography variant="body2" sx={{ fontSize: '12px' }}>
                      {new Date(item?.inspectionDate).toLocaleDateString("en-US", { 
                        year: "numeric", 
                        month: "long", 
                        day: "numeric" 
                      })}
                    </Typography>
                  </Box>
                )}
              </Box>

              {/* Actions */}
              <Box sx={{ borderTop: '1px solid #f0f0f0', pt: 2 }}>
                {Number(status) === 9 ? (
                  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <IconButton
                      size="small"
                      onClick={() => handleModeChange("UNARCHIVE", item.id)}
                      sx={{ color: primaryColor }}
                    >
                      <img
                        src={archiveIcon}
                        alt="Unarchive"
                        title="Unarchive"
                        style={{ width: '20px' }}
                      />
                    </IconButton>
                  </Box>
                ) : !expandedRows[item.id] ? (
                  <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap', justifyContent: 'center' }}>
                    {queryParams?.hide ? (
                      (item?.status == 0 || item?.status == 1) && (
                        <>
                          <IconButton
                            size="small"
                            onClick={() => handleAssigninspectionClick(item)}
                            sx={{ color: primaryColor }}
                          >
                            <img
                              src={assignInspectionIcon}
                              alt="Assign Inspection"
                              title="Assign Inspection"
                              style={{ width: '20px' }}
                            />
                          </IconButton>
                           {assignModalIsOpen && selectedItem && (
                                    <AssignInspectionModal
                                      getRequestsList={getRequestsList}
                                      isOpen={assignModalIsOpen}
                                      item={selectedItem} // Use the stored selected item
                                      onRequestClose={() => handleCloseAssignModal()}
                                    />
                                  )}
                        </>
                      )
                    ) : (
                      <NavLink
                        to="/request-form"
                        state={{ requestId: item.id, requestData: item }}
                        style={{ textDecoration: "none" }}
                      >
                        <IconButton size="small" sx={{ color: primaryColor }}>
                          <img
                            src={editIcon}
                            alt="Edit"
                            title="Edit Form"
                            style={{ width: '20px' }}
                          />
                        </IconButton>
                      </NavLink>
                    )}

                    {!queryParams?.hide && (
                      <>
                        <NavLink
                          to="/view-pdf-report"
                          state={{ requestId: item.id, requestData: item }}
                          style={{ textDecoration: "none" }}
                        >
                          <IconButton size="small" sx={{ color: primaryColor }}>
                            <img
                              src={pdficon}
                              alt="View PDF"
                              title="View PDF"
                              style={{ width: '20px' }}
                            />
                          </IconButton>
                        </NavLink>

                        {status <= 1 && (
                          <ReminderButton itemId={item.id} status={status} />
                        )}

                        <RequestTimeline itemId={item.id} />

                        <Button
                          size="small"
                          variant="contained"
                          onClick={() => handleViewMore(item.id)}
                          sx={{
                            backgroundColor: "#0050A4",
                            color: "white",
                            fontSize: "10px",
                            minWidth: '70px',
                            height: '28px',
                            '&:hover': {
                              backgroundColor: "#003d82"
                            }
                          }}
                        >
                          View More
                        </Button>
                      </>
                    )}
                  </Box>
                ) : (
                  <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap', justifyContent: 'center' }}>
                    {queryParams?.hide ? (
                      (item?.status == 0 || item?.status == 1) && (
                        <>
                          <IconButton
                            size="small"
                            onClick={() => handleAssigninspectionClick(item)}
                            sx={{ color: primaryColor }}
                          >
                            <img
                              src={assignInspectionIcon}
                              alt="Assign Inspection"
                              title="Assign Inspection"
                              style={{ width: '20px' }}
                            />
                          </IconButton>
                           {assignModalIsOpen && selectedItem && (
                                    <AssignInspectionModal
                                      getRequestsList={getRequestsList}
                                      isOpen={assignModalIsOpen}
                                      item={selectedItem} // Use the stored selected item
                                      onRequestClose={() => handleCloseAssignModal()}
                                    />
                                  )}
                        </>
                      )
                    ) : (
                      <NavLink
                        to="/request-form"
                        state={{ requestId: item.id, requestData: item }}
                        style={{ textDecoration: "none" }}
                      >
                        <IconButton size="small" sx={{ color: primaryColor }}>
                          <img
                            src={editIcon}
                            alt="Edit"
                            title="Edit Form"
                            style={{ width: '20px' }}
                          />
                        </IconButton>
                      </NavLink>
                    )}

                    {!queryParams?.hide && (
                      <>
                        <CanWrite>
                        <IconButton
                          size="small"
                          onClick={() => handleCancelClick(item.id)}
                          sx={{ color: '#ff5722' }}
                        >
                          <img
                            src={cancelInspectionIcon}
                            alt="Cancel Inspection"
                            title="Cancel Inspection"
                            style={{ width: '20px' }}
                          />
                        </IconButton>
                        </CanWrite>
                        <CancelInspectionModal
                          isOpen={modalIsOpen}
                          onRequestClose={handleCloseModal}
                          onConfirm={archiveRequest}
                        />

                        {(item?.status == 0 || item?.status == 1) && (
                          <>
                            <IconButton
                              size="small"
                             onClick={() => handleAssigninspectionClick(item)}
                              sx={{ color: primaryColor }}
                            >
                              <img
                                src={assignInspectionIcon}
                                alt="Assign Inspection"
                                title="Assign Inspection"
                                style={{ width: '20px' }}
                              />
                            </IconButton>
                            {assignModalIsOpen && selectedItem && (
                                    <AssignInspectionModal
                                      getRequestsList={getRequestsList}
                                      isOpen={assignModalIsOpen}
                                      item={selectedItem}
                                      onRequestClose={() => handleCloseAssignModal()}                                     
                                    />
                                  )}

                          </>
                        )}

                        {status <= 1 && (
                          <ReminderButton itemId={item.id} status={status} />
                        )}

                        <RequestTimeline itemId={item.id} />

                        <IconButton
                          size="small"
                          onClick={() => handleReassignClick(item)}
                          sx={{ color: primaryColor }}
                        >
                          <img
                            src={reassignIcon}
                            alt="Reassign"
                            title="Reassign"
                            style={{ width: '20px' }}
                          />
                        </IconButton>

                        <CanWrite>
                        <IconButton
                          size="small"
                          onClick={() => handleModeChange("EDIT", item.id)}
                          sx={{ color: '#666' }}
                        >
                          <img
                            src={archiveIcon}
                            alt="Archive"
                            title="Archive"
                            style={{ width: '20px' }}
                          />
                        </IconButton>
                        </CanWrite>

                        <IconButton
                          size="small"
                          onClick={() => handleOpenCopyModal(item)}
                          sx={{ color: '#0050A4' }}
                        >
                          <ContentCopyIcon sx={{ fontSize: '20px' }} />
                        </IconButton>

                        <Button
                          size="small"
                          variant="contained"
                          onClick={() => handleViewMore(item.id)}
                          sx={{
                            backgroundColor: "green",
                            color: "white",
                            fontSize: "10px",
                            minWidth: '70px',
                            height: '28px',
                            '&:hover': {
                              backgroundColor: "#2e7d32"
                            }
                          }}
                        >
                          View Less
                        </Button>
                        
                      </>
                    )}   
                  </Box>
                )}
              </Box>
            </CardContent>
          </Card>
        ))}
      </Box>  
  



          {/* Pagination */}
          <Box sx={{ p: 2, borderTop: '1px solid #ddd', backgroundColor: '#fff' }}>
            {renderPagination()}
          </Box>
        </Paper>
      ) : (
        <Loader />
      )}

      {/* Filter Modal */}
      <Dialog open={showFilterModal} onClose={() => setShowFilterModal(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ color: primaryColor, fontSize: '1.25rem', fontWeight: 600 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            Filter Options
            {hasActiveFilters() && (
              <Chip 
                label={`${Object.values(filters).filter(val =>
                  typeof val === 'string' ? val !== '' :
                    Object.values(val).some(v => v !== '')
                ).length} active`}
                size="small"
                sx={{
                  backgroundColor: `${primaryColor}15`,
                  color: primaryColor,
                }}
              />
            )}
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            {type === "ALL" && (
              <Box sx={{ mb: 3 }}>
                <label className="form-label">Status</label>
                <select
                  className="form-select"
                  value={filters.status}
                  onChange={(e) => handleFilterChange('status', e.target.value)}
                  style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                >
                  <option value="">All</option>
                  {Object.entries(statusMap).map(([key, value]) => (
                    <option key={key} value={key}>{value}</option>
                  ))}
                </select>
              </Box>
            )}

            <Box sx={{ mb: 3 }}>
              <label className="form-label">Date Range</label>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <input
                  type="date"
                  className="form-control"
                  value={filters.dateRange.startDate}
                  onChange={(e) => setFilters(prev => ({
                    ...prev,
                    dateRange: { ...prev.dateRange, startDate: e.target.value }
                  }))}
                  style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                />
                <input
                  type="date"
                  className="form-control"
                  value={filters.dateRange.endDate}
                  onChange={(e) => setFilters(prev => ({
                    ...prev,
                    dateRange: { ...prev.dateRange, endDate: e.target.value }
                  }))}
                  style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                />
              </Box>
            </Box>

            <Box sx={{ mb: 3 }}>
              <label className="form-label">Company Name</label>
              <input
                type="text"
                className="form-control"
                value={filters.companyName}
                onChange={(e) => handleFilterChange('companyName', e.target.value)}
                style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
              />
            </Box>

            <Box sx={{ mb: 3 }}>
              <label className="form-label">City</label>
              <input
                type="text"
                className="form-control"
                value={filters.siteCity}
                onChange={(e) => handleFilterChange('siteCity', e.target.value)}
                style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
              />
            </Box>

            <Box sx={{ mb: 3 }}>
              <label className="form-label">State</label>
              <input
                type="text"
                className="form-control"
                value={filters.siteState}
                onChange={(e) => handleFilterChange('siteState', e.target.value)}
                style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
              />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant="secondary"
            onClick={() => {
              setFilters({
                status: '',
                dateRange: { startDate: '', endDate: '' },
                companyName: '',
                siteCity: '',
                siteState: ''
              });
              setShowFilterModal(false);
            }}
          >
            Clear Filters
          </Button>
          <Button
            variant="primary"
            onClick={() => setShowFilterModal(false)}
          >
            Apply Filters
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete/Archive Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {actionMode === "DELETE"
              ? "Delete Confirmation"
              : actionMode === "UNARCHIVE"
              ? "Un-Archive Confirmation"
              : "Archive Confirmation"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to{" "}
          {actionMode === "DELETE"
            ? "delete"
            : actionMode === "UNARCHIVE"
            ? "Un-Archive"
            : "archive"}{" "}
          this Request?
        </Modal.Body>
        <Modal.Footer style={{ justifyContent: "space-between" }}>
          <Button
            variant="secondary"
            style={{
              color: "#0050A4",
              border: "2px solid #0050A4",
              backgroundColor: "white",
              fontWeight: "bold",
            }}
            onClick={() => setShowDeleteModal(false)}
          >
            Close
          </Button>
          <Button
            variant="danger"
            style={{
              color: "white",
              backgroundColor: "#0050A4",
              border: "1px solid #0050A4",
            }}
            onClick={handleAction}
          >
            {actionMode === "DELETE"
              ? "Delete"
              : actionMode === "UNARCHIVE"
              ? "Un-Archive"
              : "Archive"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Original Modals (unchanged) */}
      <CancelInspectionModal
        isOpen={modalIsOpen}
        onRequestClose={handleCloseModal}
        onConfirm={archiveRequest}
      />

      {assignModalIsOpen && selectedItem && (
                                    <AssignInspectionModal
                                      getRequestsList={getRequestsList}
                                      isOpen={assignModalIsOpen}
                                      item={selectedItem} // Use the stored selected item
                                      onRequestClose={() => handleCloseAssignModal()}
                                    />
                                  )}


      <ReassignModal
        show={reassignModelIsOpen}
        onHide={handleCloseReassignModel}
        requestId={reassignItem?.id}
        companyId={reassignItem?.companyId}
        siteId={reassignItem?.siteId}
        onSuccess={() => {
          getRequestsList();
          handleCloseReassignModel();
        }}
      />

      <CopyUrlsModal
        open={copyModalOpen}
        item={currentItem}
        onClose={handleCloseCopyModal}
      />
      
       

      {/* Snackbar for notifications */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
      >
        <Alert 
          onClose={() => setOpenSnackbar(false)} 
          severity="success"
          sx={{ width: '100%' }}
        >
          Operation completed successfully
        </Alert>
      </Snackbar>
    </Box>
  );
};


export default Inspections;
